import React, { useMemo } from "react";
import { useRouter } from "next/router";
import {
  Box,
  Flex,
  Text,
  Icon,
  Accordion,
  CloseButton,
  Divider,
} from "@chakra-ui/react";
import _isEmpty from "lodash/isEmpty";

// Types
import { ContentProps } from "./Sidebar.types";

// Components
import Logo from "components/Logo";
import NavItem from "./NavItem";
import SubscribeNow from "./SubscribeNow";
import Socials from "./Socials";

// Constants
import { STADER_URL } from "constants/constants";
import LiquidStaking from "./LiquidStaking";

type ActiveMenu = {
  menu: {
    key: string;
    to: string;
  };
  subMenu: {
    key: string;
    to: string;
  };
};

const Content = ({
  menuItems,
  stakingOptions,
  onClose,
  ...rest
}: ContentProps) => {
  const router = useRouter();

  const activeMenu = useMemo<ActiveMenu>(() => {
    const [, menu, subMenu] = router.pathname.split("/");
    const aMenu = menuItems.find((item: any) => item.key === menu) || {};
    const sMenu = aMenu
      ? aMenu?.subMenus?.find((item: any) => item.key === subMenu)
      : {};

    return {
      menu: aMenu,
      subMenu: sMenu,
    };
  }, [menuItems, router.pathname]);

  if (_isEmpty(activeMenu)) {
    return null;
  }

  const accordionIndex = menuItems.indexOf(activeMenu.menu);

  return (
    <Box
      bg={{ base: "brand.backgroundLight", xl: "transparent" }}
      w={{ base: "full", xl: 60 }}
      pos={{ base: "static", xl: "fixed" }}
      p="2rem 1.5rem 0px 2.5rem"
      h={{ base: "auto", xl: "90%" }}
      color="brand.textInactive"
      overflow={{ base: "none", xl: "auto" }}
      {...rest}
    >
      <Flex flexDir="column" h="100%">
        <Box mb="2rem" flexGrow={1}>
          <Flex
            alignItems="center"
            gap="0.5rem"
            mb="6"
            justifyContent={{ base: "space-between", xl: "flex-start" }}
          >
            <a href={STADER_URL}>
              <Flex alignItems="center" gap="0.5rem">
                <Icon as={Logo} />
                <Text
                  fontSize="1.5rem"
                  color="brand.textColor"
                  fontFamily="neue-bold"
                >
                  Stader
                </Text>
              </Flex>
            </a>
            <CloseButton
              display={{ base: "flex", xl: "none" }}
              onClick={onClose}
            />
          </Flex>
          <Box
            bg={{ base: "brand.background", xl: "brand.backgroundLight" }}
            borderRadius="16px"
          >
            <Accordion
              defaultIndex={[accordionIndex === -1 ? 0 : accordionIndex]}
              p="1rem 0.5rem 1.5rem 1rem"
              bg="transparent"
            >
              {menuItems.map((menu: any, index: number) => (
                <React.Fragment key={menu.key}>
                  <NavItem
                    menu={menu}
                    width="100%"
                    showChevron={menuItems.length > 1}
                  />
                  {index !== menuItems.length - 1 && (
                    <Divider borderColor="brand.separator" />
                  )}
                </React.Fragment>
              ))}
            </Accordion>
          </Box>

          <Box mt="2.5rem">
            <LiquidStaking stakingOptionsData={stakingOptions} />
          </Box>
        </Box>

        {/* <Flex flexDir="column" justifyContent="space-between"> */}
        <Box mt="auto" position="relative" bottom="0" mb="2rem">
          <SubscribeNow />
        </Box>
        <Box position="relative" bottom="0" pb="0rem" mb="0px" mt="auto">
          <Socials />
        </Box>
      </Flex>
    </Box>
  );
};

export default Content;
